<template>
  <div :class="classes">
    <div class="normal">
      <slot />
    </div>
    <div class="no-padding">
      <slot name="bottom" />
    </div>
    <div class="filter-btns"><slot name="btns" /></div>
  </div>
</template>

<script>
export default {
  name: 'RtListFilter',
  data() {
    return {
      hasPaddingBottom: false
    };
  },
  computed: {
    classes() {
      return [
        'rt-list-filter',
        {
          'has-padding-bottom': this.hasPaddingBottom
        }
      ];
    },
    hasBottom() {
      return this.$slots.bottom;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.reLayout();
    });
  },
  methods: {
    reLayout() {
      let $form = document.querySelector('.rt-list-filter form');
      let $lastrow = $form ? $form.lastElementChild : null;
      if ($lastrow) {
        let children = $lastrow.children;
        let spans = Array.from(children).reduce((acc, item) => {
          let span = Array.from(item.classList)
            .join(',')
            .match(/el-col-(\d+)/)[1];
          return Number(span) + acc;
        }, 0);
        if ((spans && Number(spans) % 24 == 0) || this.hasBottom) {
          this.hasPaddingBottom = true;
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtListFilter.vue?0da2ce6c